<details class="container__text container__text--center markdown-container text">
  <summary>{{question}}</summary>
  <div class="text" [innerHTML]="markdown"></div>
</details>
